var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 24,
    viewBox: "0 0 88 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4738 10.663H25.7617V23.413H21.8744L20.5237 21.163C18.4153 23.0543 15.7689 24 12.5843 24C10.3442 24 8.27975 23.587 6.391 22.7609C4.52421 21.9348 2.98686 20.663 1.77894 18.9457C0.59298 17.2283 0 15.2065 0 12.8804V11.1196C0 7.64131 1.24086 4.92391 3.72259 2.96739C6.22628 0.989131 9.36688 0 13.1444 0C16.0654 0 18.569 0.597826 20.6555 1.79348C22.7419 2.98913 24.1584 4.61957 24.9051 6.68478L18.613 8.34783C18.1518 7.28261 17.427 6.44565 16.4387 5.83696C15.4724 5.22826 14.3413 4.92391 13.0456 4.92391C11.2886 4.92391 9.83907 5.44565 8.69703 6.48913C7.555 7.51087 6.98398 8.98913 6.98398 10.9239V13.0761C6.98398 14.9457 7.555 16.413 8.69703 17.4783C9.86103 18.5435 11.3325 19.0761 13.1114 19.0761C15.8347 19.0761 17.7674 17.7391 18.9095 15.0652H13.4738V10.663Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8366 23.413V0.586957H36.3923L48.219 13.5H48.2848V0.586957H54.8076V23.413H48.4825L36.4253 10.2065H36.3594V23.413H29.8366Z",
    fill: "#F1935C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6299 23.413L78.2792 20.0217H66.0902L64.7066 23.413H57.492L68.0009 0.391305H76.9285L87.2727 23.413H79.6299ZM68.0997 15.163H76.3356L72.2835 5.08696H72.2176L68.0997 15.163Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2be3f64ca618afcab3bb14c55175b119.svg";
export { ForwardRef as ReactComponent };